import { useState } from "react";
import { useTranslation } from "react-i18next";
import { removePagingGroup } from "../../../apiclients/streamsapi_bridge"
import { useLocation, useNavigate } from "react-router";
import {
    MDBAlert,
    MDBBtn,
    MDBDatatable,
    MDBIcon,
    MDBModalFooter,
    MDBSpinner,
} from "mdb-react-ui-kit";

function RemovePagingGroup(props) {
    const [isError, setError] = useState(false);
    const [isLoading, setisLoading] = useState(false);

    const location = useLocation();
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    console.log("RemovePagingGroup : " + JSON.stringify(props));
    const deletePagingGroup = async () => {
        console.log("Deleting paging Groups:::::::::");
        let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
        let paramsjo = {};
        paramsjo.pagingId = props.paramsJo.pagingId;
        paramsjo.siteid = siteid;
        paramsjo.group_no = props.paramsJo.groupno;
        paramsjo.groupname = props.paramsJo.groupname;
        setisLoading(true);
        let serverResponse = await removePagingGroup(siteid, paramsjo);
        if (!serverResponse.ok) {
            console.log("Network is not ok ");
            setError(true);
            setTimeout(() => {
                setisLoading(false);
                props.onClose();
            }, 1000);


        } else {
            props.onClose();

            //window.location.href = "/pslanding";

            window.location.reload();
            localStorage.setItem("s_message", `Paging Group ${props?.paramsJo?.groupname} removed successfully.`);
            navigate("/pslanding", {
                state: { tab: "tab3" },
            });
            window.location.reload();
        }
    }

    return (
        <>
            <div className="d-flex align-items-center bg-danger bg-opacity-25 p-3  rounded-3 square border border-2 border-danger">
                <MDBIcon fas icon="ban" className="me-3" size="lg" color="danger" />
                {props.paramsJo?.devices ? (
                    <div>
                        {t("deletePagingGroupConfirm", {
                            Groupname: `${props.paramsJo?.groupname}`,
                            macAdress: `(${props.paramsJo?.devices})`
                        })}
                    </div>
                ) : (
                    <div>
                        {t("RmPagingGroupBackoffice")} {props.paramsJo?.groupname}
                    </div>
                )}
            </div>

            <MDBModalFooter className='p-0 mt-3 pt-2'>
                <MDBBtn color="secondary" onClick={(e) => props.onClose(e)}>
                    {t("close")}
                </MDBBtn>
                <MDBBtn onClick={deletePagingGroup}>{t("remove")}</MDBBtn>
            </MDBModalFooter>
            {isLoading && (
                <div>
                    <div className="loadingclass-popup"></div>
                    <div className="popup-bg-loader loader_align">
                        <MDBBtn disabled>
                            <MDBSpinner
                                size="sm"
                                role="status"
                                tag="span"
                                className="me-2"
                            />
                            Loading...
                        </MDBBtn>
                    </div>
                </div>
            )
            }
            {isError && (
                <MDBAlert
                    open
                    className="alert-center"
                    color="danger"
                    autohide
                    position="bottom-right"
                    delay={100000}
                >
                    Internal Server Error
                </MDBAlert>
            )}
        </>
    )
}
export default RemovePagingGroup;